import CommunityService from './communityService'

export default CommunityService